import ScheduledCoverageChart from "../ScheduledCoverageChart";
import React, { useState, useEffect } from "react";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import StackedBarChartIcon from "@mui/icons-material/StackedBarChart";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
import ListAltIcon from "@mui/icons-material/ListAlt";
import PersonIcon from "@mui/icons-material/Person";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DateCardSalesInfo from "../DateCardSalesInfo";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import Button from "@mui/material/Button";
import PersonCard from "../PersonCard";
import ShiftCard from "../ShiftCard";
import NewShiftCard from "../NewShiftCard";
import NewOpenShiftCard from "../NewOpenShiftCard";
import HoursOfOpsButton from "./HoursOfOpsButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import WeatherEventsCard from "../WeatherEventsCard";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";
import FlagIcon from "@mui/icons-material/Flag";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import SaveIcon from "@mui/icons-material/Save";
import FolderSpecialIcon from "@mui/icons-material/FolderSpecial";
import SaveAsTemplateButton from "../../action_bar_components/save_schedule_buttons/SaveAsTemplateButton";
import LoadFromTemplateButton from "../../action_bar_components/load_schedule_buttons/LoadFromTemplateButton";
import VisualCustomLineChart from "../VisualCustomLineChart";
import VisualChartModal from "../VisualChartModal";
import ResizableDailyShiftCard from "./ResizableDailyShiftCard";
import ResizableDailyBreakCard from "./ResizeableDailyBreakCard";
import VisualDailyReportModal2 from "../VisualDailyReportModal2";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import {
  generateLaborSummary,
  getDailyScheduleHourRange,
  get_t_str,
  get_t_str_shortened,
} from "../../../../../helpers/helpers";
import DailyBreakCard from "./DailyBreakCard";
import FilteredDepartmentShiftCard from "../FilteredDepartmentShiftCard";
import { getOutOfFilterShifts } from "../departmentFilter";
import { otherStoreShiftLabel } from "../otherStoreShifts";
import DailyNoLaborModelMetricsCard from "../DailyNoLaborModelMetricsCard";

export default function DailySchedule(props) {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const [employmentGuide, setEmploymentGuide] = React.useState(true);
  const [coverageGraph, setCoverageGraph] = React.useState(false);
  const [availabilityChecked, setAvailabilityChecked] = React.useState(true);
  const [preferenceChecked, setPreferenceChecked] = React.useState(true);

  function handleExpandClick(event) {
    event?.stopPropagation?.();
    setIsExpanded((prevState) => !prevState);
  }

  function handleExpandAxisClick() {
    if (hasIntradayModel && !isExpanded) {
      setIsExpanded(true);
    }
  }

  function handleExpandAxisKeyDown(event) {
    if (!hasIntradayModel || isExpanded) {
      return;
    }
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      setIsExpanded(true);
    }
  }

  function handleEmploymentGuideClick() {
    setEmploymentGuide(true);
    setCoverageGraph(false);
  }

  function handleCoverageGraphClick() {
    setCoverageGraph(true);
    setEmploymentGuide(false);
  }


  const [
    locked,
    date,
    date_str,
    date_dow,
    date_name,
    todays_date_yes,
    dow_name,
    day_shifts,
    day_request_off,
    dow_availability,
    edit_mode,
    day_in_past,
    forecasted_labor_day,
    actual_schedule_labor_day,
    calculated_earned_labor_day,
    actual_used_labor_vs_earned_day,
    adjustment_chosen,
    forecast_sales,
    actual_sales,
    dow_default_operating_hours,
    day_operating_hours,
    day_time_off_requests,
    historical_sales_context,
    day_other_store_shifts,
    used_day_shifts,
    adjustments_history,
    day_shifts_for_length
  ] = props.get_date_info(props.dowSelected);

  const hasIntradayModel = props.laborModelEnabled &&
    (props.checkedMetricsToggle ? calculated_earned_labor_day : forecasted_labor_day)?.length > 0;
  const showIntraday = hasIntradayModel && isExpanded;

  const daily_forecast_exclude_date =
    props.filter_df_to_day(props.forecast_exclude_dates, "date", date_str)
      .length > 0;
  const daily_blackout_date = props.filter_df_to_day(
    props.blackout_dates || [],
    "date",
    date_str
  );

  const daily_batch_guidance =
    date_str in props.batch_guidance ? props.batch_guidance[date_str] : {};

  const daily_intraday_metrics =
    date_str in props.intraday_metrics ? props.intraday_metrics[date_str] : {};

  const actual_intraday_metrics =
    date_str in props.actual_intraday_metrics
      ? props.actual_intraday_metrics[date_str]
      : {};

  const hasDailyActualMetrics =
    (actual_used_labor_vs_earned_day?.length || 0) > 0 ||
    (calculated_earned_labor_day?.length || 0) > 0;
  const dailyChartEarnedToggle =
    !!props.checkedMetricsToggle && hasDailyActualMetrics;

  // The role band is scoped to this day, so its pair only reads once the day
  // has started in store time. The person cards keep week-to-date hours, which
  // is what they show in this view either way.
  const showDayActualHours =
    !!props.showActualHours &&
    !!props.storeBusinessDate &&
    date_str <= props.storeBusinessDate;

  // Availability, time off, other-store and out-of-department cards are all
  // plan. The week view drops them in actual mode; the daily view draws its own
  // rows, so it needs the same rule stated again here.
  const showPlanCells = !props.showActualHours;

  // Which report this day's button opens. Showing actuals means the plan is no
  // longer the thing being read, so the planned report gives way to the one
  // about what happened: the after-action report for a day that is over, and
  // the live one for the day still running.
  const isStoreToday =
    !!props.storeBusinessDate && date_str === props.storeBusinessDate;
  const showLiveActionReport =
    !!props.liveLaborEnabled && isStoreToday && !!props.checkedMetricsToggle;
  const dailyReportLabel = props.checkedMetricsToggle
    ? "After Action Report"
    : "Planned Action Report";

  // On the daily timeline a card's position IS the claim about when the work
  // happened. Left on the scheduled start, a shift planned 9-5 but worked 11-3
  // reads "11:00a - 3:00p" while sitting in the 9-5 slot, which is a picture of
  // something that did not happen. Returns null when there is no punch, so the
  // card falls back to the plan and can still be resized.
  // seatedMemberId is whose row the card is on. A covered shift is re-seated
  // onto the person who worked it, so checking the punch against the shift's
  // original assignment would reject the very times the card prints and leave
  // it sized from the plan. Omitted for the axis, which only needs to bound
  // whatever ends up drawn.
  const actualGeometry = (shift, seatedMemberId) => {
    if (!props.showActualHours) return null;
    // An actual card is already drawn from its own punch: its times, length and
    // breaks are the worked ones. There is nothing to resolve.
    if (shift?.is_actual_card) return null;
    const actual =
      props.actualTimesByPublishedId?.[shift?.publishedschedule?.id];
    if (!actual) return null;
    const punchOwnerId = actual.store_team_member_id;
    if (
      seatedMemberId !== undefined &&
      punchOwnerId != null &&
      seatedMemberId != null &&
      punchOwnerId !== seatedMemberId
    ) {
      return null;
    }
    // The break renderers read two numbered slots, so the punch's breaks are
    // reshaped into the same form rather than teaching every caller a new one.
    const unpaid = actual.unpaid_breaks || [];
    return {
      start: actual.shift_start,
      length: Math.max(0, actual.shift_end - actual.shift_start),
      break_start: unpaid[0]?.break_start ?? null,
      break_length: unpaid[0]?.break_length ?? 0,
      break_start_2: unpaid[1]?.break_start ?? null,
      break_length_2: unpaid[1]?.break_length ?? 0,
      paid_breaks: actual.paid_breaks || [],
    };
  };

  // A shift as it should be drawn: the punch where there is one, the plan
  // otherwise. Breaks included, so a card never shows worked hours around a
  // break somebody did not take then.
  // A break belongs inside the shift it was taken on. Once a card is drawn from
  // punch times, a marker positioned from anything else can land past the bar,
  // where it reads as a stray grey block over the empty row. Anything that does
  // not fit within the drawn span is not describing this shift, so it is not
  // drawn.
  const breakFitsShift = (drawn, start, length) => {
    const from = Number(start);
    const span = Number(length);
    if (!Number.isFinite(from) || !Number.isFinite(span) || span <= 0) {
      return false;
    }
    const shiftStart = Number(drawn?.shift_start);
    const shiftEnd = Number(drawn?.shift_end);
    if (!Number.isFinite(shiftStart) || !Number.isFinite(shiftEnd)) return false;
    // A minute of slack, since punch times are not on the quarter-hour grid.
    const tolerance = 1 / 60;
    return from >= shiftStart - tolerance && from + span <= shiftEnd + tolerance;
  };

  // Planned shifts hold two numbered break slots; a punch can record more, and
  // the hours subtract all of them. Drawing only two would leave later breaks
  // as apparently worked time.
  const unpaidBreaksToDraw = (shift) => {
    if (Array.isArray(shift?.unpaid_breaks) && shift.unpaid_breaks.length > 0) {
      return shift.unpaid_breaks;
    }
    return [
      { break_start: shift?.break_start, break_length: shift?.break_length },
      { break_start: shift?.break_start_2, break_length: shift?.break_length_2 },
    ];
  };

  const displayShift = (shift, seatedMemberId) => {
    const geometry = actualGeometry(shift, seatedMemberId);
    if (!geometry) return shift;
    return {
      ...shift,
      shift_start: geometry.start,
      shift_length: geometry.length,
      shift_end: geometry.start + geometry.length,
      break_start: geometry.break_start,
      break_length: geometry.break_length,
      break_start_2: geometry.break_start_2,
      break_length_2: geometry.break_length_2,
      paid_breaks: geometry.paid_breaks,
    };
  };

  // Offsets on this row are cumulative, so the shift before has to be measured
  // the same way or everything after it slides.
  const displayEnd = (shift, seatedMemberId) => {
    const geometry = actualGeometry(shift, seatedMemberId);
    return geometry
      ? geometry.start + geometry.length
      : shift?.shift_end;
  };

  const daily_reservation_summary =
    props.reservation_summary?.find((r) => r.date === date_str) || null;

  const daily_open_shifts = props.filter_df_to_day(
    props.open_shifts,
    "date",
    date_str
  );
  const unfilteredDayShifts = props.isCopilotOn
    ? day_shifts
    : props.filter_df_to_day(
        props.all_data_full?.actual_schedule || [],
        "date",
        date_str
      );

  const day_num_employees_working = new Set(
    day_shifts_for_length
      ?.filter(
        (shift) =>
          shift.store_team_member !== null && shift.other_store === false
      )
      ?.map((shift) => shift.store_team_member)
  )?.size;



  const res = props.combine_data(
    forecasted_labor_day,
    actual_schedule_labor_day
  );

  function grid_lines(hours) {
    // Ensure hours is a valid positive number
    if (hours < 0) return null;

    return [...Array(hours + 1).keys()].map((v, i) => {
      return (
        <div
          key={i} // Always include a key when rendering lists in React
          className="h-full border-l border-gray-200 absolute"
          style={{ left: `${hour_increment * i + 15}%` }}
        ></div>
      );
    });
  }

  const daily_weather = props.filter_df_to_day(props.weather, "date", date_str);
  const daily_events = props.filter_df_to_day(props.events, "date", date_str);

  const { start_h: planned_start_h, end_h: planned_end_h } =
    getDailyScheduleHourRange(
      dow_default_operating_hours,
      day_operating_hours,
      day_shifts
    );

  // The axis is built from operating hours and planned shifts. Once cards are
  // positioned from punches, somebody who clocked in before open or out after
  // close falls off the timeline: a negative offset, or a bar running past the
  // end. Widen the range to hold whatever is actually drawn.
  const { start_h, end_h } = React.useMemo(() => {
    let from = planned_start_h;
    let to = planned_end_h;
    if (props.showActualHours) {
      (day_shifts || []).forEach((shift) => {
        const geometry = actualGeometry(shift);
        if (!geometry || !Number.isFinite(geometry.start)) return;
        from = Math.min(from, Math.floor(geometry.start));
        to = Math.max(to, Math.ceil(geometry.start + geometry.length));
      });
      // Actual cards are not in day_shifts, so the axis reads them directly or
      // it would never make room for work that ran before open or after close.
      (props.actualCards || []).forEach((card) => {
        if (card?.date !== date_str) return;
        if (!Number.isFinite(card.shift_start)) return;
        from = Math.min(from, Math.floor(card.shift_start));
        to = Math.max(to, Math.ceil(card.shift_end));
      });
    }
    return { start_h: from, end_h: to };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    planned_start_h,
    planned_end_h,
    props.showActualHours,
    day_shifts,
    props.actualTimesByPublishedId,
    props.actualCards,
    date_str,
  ]);

  const hour_increment = end_h > start_h ? 85 / (end_h - start_h) : 0;

  function format_hour(hour) {
    if (hour === 24) {
      return "12A";
    }
    if (hour === 12) {
      return "12P";
    }
    const h = hour % 24;
    return (h % 12) + (h > 12 ? "P" : "A");
  }



  // The inline chart plotted forecast against schedule whatever the mode, so
  // switching to actuals left it drawing the plan. The popped-out chart already
  // swaps to earned against actual; this is the same swap, in the chart you see
  // without opening anything.
  const label1 = dailyChartEarnedToggle ? "Earned" : "Forecasted";
  const label2 = dailyChartEarnedToggle ? "Actual" : "Scheduled";

  // The grade and the two tiles beside the chart are the same comparison the
  // chart draws, so they follow it: earned against worked in actual mode,
  // forecast against planned otherwise. Left alone they graded the plan while
  // the chart plotted the day.
  const gradeNeededSeries = dailyChartEarnedToggle
    ? calculated_earned_labor_day
    : forecasted_labor_day;
  const gradeActualSeries = dailyChartEarnedToggle
    ? actual_used_labor_vs_earned_day
    : actual_schedule_labor_day;

  // Scheduled hours land on quarter-hour boundaries and summed cleanly, so
  // these tiles never needed rounding. Worked hours come from punches and do
  // not, which is how 37.04206083333333 reached the panel.
  const tileHours = (series) => {
    const total = Number(props.agg_column(series, "hours"));
    return Number.isFinite(total) ? total.toFixed(2) : "0.00";
  };

  // Derived, not stored. As an effect with these arrays in its dependencies it
  // ran after every render: get_date_info rebuilds them with Array.filter, so
  // each has a fresh identity, and setData then triggered the next render.
  // That is an unbounded loop, and React eventually gives up with a maximum
  // update depth error. Keyed on the data and the mode instead, both of which
  // hold their identity between renders.
  const data = React.useMemo(
    () =>
      generateLaborSummary(
        dailyChartEarnedToggle
          ? calculated_earned_labor_day
          : forecasted_labor_day,
        dailyChartEarnedToggle
          ? actual_used_labor_vs_earned_day
          : actual_schedule_labor_day,
        get_t_str,
        label1,
        label2
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      date_str,
      dailyChartEarnedToggle,
      props.all_data,
      props.store_team_member_weekly_info_view,
    ]
  );

  const [openChart, setOpenChart] = React.useState(false);
  const handleOpenChart = () => setOpenChart(true);
  const handleCloseChart = () => setOpenChart(false);

  useEffect(() => {
    setIsExpanded(false);
    setOpenChart(false);
  }, [date_str, props.store_id, hasIntradayModel]);

  const [openDailyReport2, setOpenDailyReport2] = React.useState(false);
  const handleOpenDailyReport2 = () => setOpenDailyReport2(true);
  const handleCloseDailyReport2 = () => setOpenDailyReport2(false);

  // Opening forecast adjusment modal
  const [openForecastAdjustment, setOpenForecastAdjustment] =
    React.useState(false);
  const handleOpenForecastAdjustment = () => setOpenForecastAdjustment(true);
  const handleCloseForecastAdjustment = () => setOpenForecastAdjustment(false);

  // Opening notes modal
  const [openNotes, setOpenNotes] = React.useState(false);
  const handleOpenNotes = () => setOpenNotes(true);
  const handleCloseNotes = () => setOpenNotes(false);

  // Per-group summary for the role/department bands: people beneath each
  // header, and their shifts and hours on this day.
  const groupHeaderInfo = (() => {
    const rows = props.store_team_member_weekly_info_view || [];
    const todaysShifts = (day_shifts || []).filter(
      (sh) => sh.store_team_member !== null && sh.other_store === false
    );
    const byMember = {};
    todaysShifts.forEach((sh) => {
      const entry = byMember[sh.store_team_member] || { shifts: 0, hours: 0 };
      entry.shifts += 1;
      entry.hours += sh.hours || 0;
      byMember[sh.store_team_member] = entry;
    });
    const info = {};
    let current = null;
    rows.forEach((row) => {
      if (row.isRoleHeader) {
        current = {
          people: 0,
          shifts: 0,
          hours: 0,
          actualHours: 0,
          scheduledHoursForPair: 0,
        };
        info[row.id] = current;
        return;
      }
      if (!current) return;
      current.people += 1;
      const entry = byMember[row.id];
      if (entry) {
        current.shifts += entry.shifts;
        current.hours += entry.hours;
      }
      // This band counts one day, so both sides are that day's totals. They
      // come from the week view's aggregation rather than from day_shifts,
      // which carries manager-cancelled shifts and, while Copilot is on,
      // departments the selector has hidden. info.hours keeps the raw day
      // total, so the plain label is unchanged.
      current.actualHours +=
        props.actualHoursByMemberDate?.[row.id]?.[date_str] || 0;
      current.scheduledHoursForPair +=
        props.scheduledHoursByMemberDate?.[row.id]?.[date_str] || 0;
    });
    return info;
  })();

  // Day-state toggles (same actions as the week view's day menu)
  const isFlagged = !!daily_forecast_exclude_date;
  const isBlocked = (daily_blackout_date?.length ?? 0) > 0;
  const toggleFlagged = () => {
    if (isFlagged) {
      props.deleteForecastExcludeDate?.(date_str);
    } else {
      props.saveForecastExcludeDate?.({ date: date_str, reason: null });
    }
  };
  const toggleBlocked = () => {
    if (isBlocked) {
      props.deleteBlackoutDate?.(date_str);
    } else {
      props.saveBlackoutDate?.(date_str);
    }
  };
  const dtp = props.dailyTemplateProps || {};
  const [dayMenuAnchor, setDayMenuAnchor] = React.useState(null);
  const [saveDailyTemplateOpen, setSaveDailyTemplateOpen] = React.useState(false);
  const [loadDailyTemplateOpen, setLoadDailyTemplateOpen] = React.useState(false);

  // Availability is a fact about the person, not a claim about the day, so it
  // reads the same in either mode and the chip stays the only thing deciding
  // whether to draw it. A mode-specific default here would leave the chip
  // saying it was on while nothing rendered.
  const displayChip = (label, checked, onChange, Icon) => (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={onChange}
      className={`inline-flex items-center gap-1 h-[24px] px-2.5 rounded-full text-xxs font-semibold whitespace-nowrap transition-colors duration-150 ${
        checked
          ? "bg-violet-100 text-violet-700"
          : "bg-slate-100 text-slate-500 hover:text-slate-700"
      }`}
    >
      <Icon style={{ fontSize: "12px" }} />
      {label}
    </button>
  );

  const stateToggle = (label, active, onClick, Icon, tooltip) => (
    <Tooltip title={tooltip}>
      <button
        type="button"
        aria-pressed={active}
        onClick={onClick}
        className={`inline-flex items-center gap-1.5 h-[30px] rounded-lg border text-xs font-semibold transition-colors duration-150 ${
          props.windowWidth > 1279 ? "px-2.5" : "w-[30px] justify-center"
        } ${
          active
            ? "bg-violet-50 border-violet-200 text-violet-700"
            : "bg-white border-slate-200 text-slate-500 hover:text-slate-700 hover:border-slate-300"
        }`}
      >
        <Icon style={{ fontSize: "14px" }} />
        {props.windowWidth > 1279 && label}
      </button>
    </Tooltip>
  );

  const actionButton = (tooltip, onClick, Icon) => (
    <Tooltip title={tooltip}>
      <button
        type="button"
        onClick={onClick}
        className="w-[30px] h-[30px] inline-flex items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-500 hover:text-slate-700 hover:border-slate-300 transition-colors duration-150"
      >
        <Icon style={{ fontSize: "16px" }} />
      </button>
    </Tooltip>
  );

  return (
    <div>
      <div className="w-full flex items-stretch">
        {/* Left cell: back link + display toggles */}
        <div className="w-[15%] py-2.5 pl-2 pr-3 flex flex-col justify-center gap-2">
          <button
            type="button"
            onClick={() => props.toggleDailyWeekly()}
            className="self-start inline-flex items-center gap-1 text-xs text-slate-500 hover:text-slate-900"
          >
            <ArrowBackIcon style={{ fontSize: "14px" }} />
            Weekly view
          </button>
          <div className="flex flex-col items-start gap-1.5">
            {displayChip(
              "Show unavailable",
              availabilityChecked,
              () => setAvailabilityChecked((prev) => !prev),
              VisibilityOutlinedIcon
            )}
            {displayChip(
              "Show preferences",
              preferenceChecked,
              () => setPreferenceChecked((prev) => !prev),
              StarBorderOutlinedIcon
            )}
          </div>
        </div>

        {/* Right cell: date + controls on the first line, facts on the second */}
        <div className="w-[85%] border-l border-gray-200 flex flex-col justify-center gap-2 pl-4 pr-0 py-2.5">
          <div className="flex items-center gap-4">
            <h2
              className={`text-xl leading-7 font-semibold whitespace-nowrap ${
                todays_date_yes ? "text-violet-700" : "text-slate-900"
              }`}
            >
              {date_name}
            </h2>
            <WeatherEventsCard
              element="weather"
              view="daily"
              size="lg"
              daily_weather={daily_weather}
              daily_events={daily_events}
              date_str={date_str}
              date_name={date_name}
              saveEvent={props.saveEvent}
              updateEvent={props.updateEvent}
              deleteEvent={props.deleteEvent}
              eventAttachmentProps={props.eventAttachmentProps}
              saveEventFinished={props.saveEventFinished}
              setSaveEventFinished={props.setSaveEventFinished}
              setOpenNotes={setOpenNotes}
            />
          </div>
          <div className="flex items-center gap-5">
          <DateCardSalesInfo
            view="daily"
            forecast_sales={forecast_sales}
            actual_sales={actual_sales}
            date_name={date_name}
            day_of_week_str={props.day_of_week_str}
            edit_mode={edit_mode}
            lock_day={props.lock_day}
            locked={locked}
            d={props.dowSelected}
            day_in_past={day_in_past}
            todays_date_yes={todays_date_yes}
            adjustment_chosen={adjustment_chosen}
            addForecastAdjustment={props.addForecastAdjustment}
            addAdjustmentFinished={props.addAdjustmentFinished}
            date_str={date_str}
            daily_weather={daily_weather}
            daily_events={daily_events}
            saveEvent={props.saveEvent}
            updateEvent={props.updateEvent}
            deleteEvent={props.deleteEvent}
            eventAttachmentProps={props.eventAttachmentProps}
            saveEventFinished={props.saveEventFinished}
            setSaveEventFinished={props.setSaveEventFinished}
            openForecastAdjustment={openForecastAdjustment}
            handleOpenForecastAdjustment={handleOpenForecastAdjustment}
            handleCloseForecastAdjustment={handleCloseForecastAdjustment}
            setOpenForecastAdjustment={setOpenForecastAdjustment}
            setOpenNotes={setOpenNotes}
            daily_forecast_exclude_date={daily_forecast_exclude_date}
            historical_sales_context={historical_sales_context}
            defaultHours={dow_default_operating_hours?.[0]}
            specialHours={day_operating_hours?.[0]}
            hoo={
              day_operating_hours.length > 0
                ? day_operating_hours[0]
                : dow_default_operating_hours[0]
            }
            daily_intraday_metrics={daily_intraday_metrics}
            actual_intraday_metrics={actual_intraday_metrics}
            daily_reservation_summary={daily_reservation_summary}
            reservation_summary={props.reservation_summary}
            adjustments_history={adjustments_history}
            manualSalesInputEnabled={props.manualSalesInputEnabled}
          />
          <HoursOfOpsButton
            date_name={date_name}
            hoo={
              day_operating_hours.length > 0
                ? day_operating_hours[0]
                : dow_default_operating_hours[0]
            }
            get_t_str={props.get_t_str}
            dow_name={dow_name}
            edit_hoo={props.edit_hoo}
            default_checked={false}
            start_qhnum={props.start_qhnum}
            view="daily"
          />
          {day_num_employees_working > 0 && (
            <Tooltip
              title={`${day_num_employees_working} ${
                day_num_employees_working === 1 ? "employee" : "employees"
              } scheduled`}
            >
              <span className="h-[26px] inline-flex items-center gap-1.5">
                <span className="text-xxs leading-none text-slate-400">Staff</span>
                <span className="text-sm leading-none font-semibold text-slate-900 tabular-nums inline-flex items-center gap-0.5">
                  <PersonIcon style={{ fontSize: "14px" }} className="text-slate-500" />
                  {day_num_employees_working}
                </span>
              </span>
            </Tooltip>
          )}

            <div className="flex-1" />
          <div className="flex items-center gap-1.5">
            {stateToggle(
              locked ? "Locked" : "Lock",
              locked,
              () => props.lock_day(props.dowSelected),
              locked ? LockIcon : LockOpenOutlinedIcon,
              locked
                ? "Locked: the autoscheduler will not change this day. Click to unlock."
                : "Lock this day so the autoscheduler leaves it alone"
            )}
            {stateToggle(
              isFlagged ? "Flagged" : "Flag",
              isFlagged,
              toggleFlagged,
              isFlagged ? FlagIcon : FlagOutlinedIcon,
              isFlagged
                ? "Flagged as an outlier: this day's sales are excluded from forecasting. Click to unflag."
                : "Flag this day as an outlier for forecasting"
            )}
            {stateToggle(
              isBlocked ? "Blocked" : "Block time off",
              isBlocked,
              toggleBlocked,
              isBlocked ? EventBusyIcon : EventAvailableIcon,
              isBlocked
                ? "Blocked from time off requests. Click to unblock."
                : "Block this date from time off requests"
            )}
          </div>

          <span className="w-px h-6 bg-slate-200" />

          <div className="flex items-center gap-1.5">
            <WeatherEventsCard
              element="notes"
              view="daily"
              date_str={date_str}
              date_name={date_name}
              daily_weather={daily_weather}
              daily_events={daily_events}
              saveEvent={props.saveEvent}
              updateEvent={props.updateEvent}
              deleteEvent={props.deleteEvent}
              eventAttachmentProps={props.eventAttachmentProps}
              saveEventFinished={props.saveEventFinished}
              setSaveEventFinished={props.setSaveEventFinished}
              openNotes={openNotes}
              handleOpenNotes={handleOpenNotes}
              handleCloseNotes={handleCloseNotes}
              setOpenNotes={setOpenNotes}
            />
            {hasIntradayModel && actionButton("Intraday staffing levels", handleOpenChart, StackedLineChartIcon)}
            {showLiveActionReport
              ? actionButton(
                  "Live Action Report",
                  // A tab, not a modal: the task drawer would sit under a
                  // modal's backdrop.
                  () => props.openLiveAction?.(),
                  PlayCircleOutlineIcon
                )
              : actionButton(
                  dailyReportLabel,
                  handleOpenDailyReport2,
                  ListAltIcon
                )}
            {/* Loading a daily template rewrites the planned shifts, which
                actual mode has hidden. Same rule as the main Tools menu. */}
            {showPlanCells && dtp.saveDailyScheduleAsTemplate && (
              <>
                {actionButton("More", (e) => setDayMenuAnchor(e.currentTarget), MoreVertIcon)}
                <Menu
                  anchorEl={dayMenuAnchor}
                  open={Boolean(dayMenuAnchor)}
                  onClose={() => setDayMenuAnchor(null)}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      mt: 1,
                      minWidth: 220,
                      borderRadius: 2,
                      border: "1px solid #e2e8f0",
                      boxShadow: "0 12px 28px rgba(15, 23, 42, 0.12)",
                      "& .MuiMenuItem-root": { minHeight: 36, fontSize: 13 },
                    },
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      setDayMenuAnchor(null);
                      setSaveDailyTemplateOpen(true);
                    }}
                  >
                    <ListItemIcon>
                      <SaveIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Save as daily template</ListItemText>
                  </MenuItem>
                  {!day_in_past &&
                    dtp.loadDailyFromTemplate &&
                    dtp.dailyTemplateNames?.length > 0 && (
                    <MenuItem
                      onClick={() => {
                        setDayMenuAnchor(null);
                        setLoadDailyTemplateOpen(true);
                      }}
                    >
                      <ListItemIcon>
                        <FolderSpecialIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>Load from daily template</ListItemText>
                    </MenuItem>
                  )}
                </Menu>
                <SaveAsTemplateButton
                  hideTrigger
                  mode="daily"
                  open={saveDailyTemplateOpen}
                  onClose={() => setSaveDailyTemplateOpen(false)}
                  saveScheduleAsTemplate={(name) =>
                    dtp.saveDailyScheduleAsTemplate(name, date_str)
                  }
                  template_names={dtp.dailyTemplateNames}
                  formatDate={dtp.formatDate}
                />
                {!day_in_past && dtp.loadDailyFromTemplate && (
                  <LoadFromTemplateButton
                    hideTrigger
                    mode="daily"
                    open={loadDailyTemplateOpen}
                    onClose={() => setLoadDailyTemplateOpen(false)}
                    week_already_started={day_in_past}
                    loadFromTemplate={(name, keep) =>
                      dtp.loadDailyFromTemplate(name, keep, date_str)
                    }
                    deleteScheduleTemplate={dtp.deleteDailyScheduleTemplate}
                    template_names={dtp.dailyTemplateNames}
                    loadFromTemplateFinished={dtp.loadFromTemplateFinished}
                    setLoadFromTemplateFinished={dtp.setLoadFromTemplateFinished}
                  />
                )}
              </>
            )}
          </div>
          </div>
        </div>
      </div>
      <div className="w-full relative border-b border-gray-200">
        {end_h !== undefined &&
          start_h !== undefined &&
          !(end_h === 0 && start_h === 0) &&
          grid_lines(end_h - start_h)}

        {/* The creator row is a second way into making a planned shift, outside
            the cards and their gestures. */}
        {showPlanCells && edit_mode && !props.displayMode && !props.lockAllShifts && (
          <div className="w-full border-t border-gray-200 py-2 flex items-center relative">
            <div className="w-[15%] pl-2 pr-4">
              <p className="text-slate-900 font-bold text-xxs">Open shifts</p>
              <p className="text-xxs text-slate-500">
                {daily_open_shifts.length} scheduled
              </p>
            </div>
            <div
              style={{
                width: "85%",
                zIndex: 9,
                height: 32,
              }}
            >
              <NewOpenShiftCard
                paidBreakInputsEnabled={props.paidBreakInputsEnabled}
                restBreakRegulation={props.restBreakRegulation}
                weekly_or_daily="daily"
                date_str={date_str}
                addShift={props.addShift}
                store_id={props.store_id}
                get_t_str={props.get_t_str}
                date_name={date_name}
                role_names={props.role_names}
                saveShiftFinished={props.saveShiftFinished}
                setSaveShiftFinished={props.setSaveShiftFinished}
                d={props.dowSelected}
                copiedShift={props.copiedShift}
                setCopiedShift={props.setCopiedShift}
                addMultipleShifts={props.addMultipleShifts}
                role_types={props.role_types}
                businessWeekStartDayIndex={props.businessWeekStartDayIndex}
                start_qhnum={props.start_qhnum}
                schedule_day_end_qhnum={props.schedule_day_end_qhnum}
                defaultBreakLengthHours={props.defaultBreakLengthHours}
                breakRequiredWhenShiftLengthExceeds={
                  props.breakRequiredWhenShiftLengthExceeds
                }
                secondBreakShiftLengthThreshold={
                  props.secondBreakShiftLengthThreshold
                }
                businessDeclineShiftOptionEnabled={
                  props.businessDeclineShiftOptionEnabled
                }
              />
            </div>
          </div>
        )}

        {(props.showActualHours ? [] : daily_open_shifts)?.map((shift) => {
          return (
            <div
              key={shift.id}
              className="w-full border-t border-gray-200 py-2 flex items-center relative"
            >
              <div className="w-[15%] pl-2 pr-4">
                <div className="flex flex-1 items-center gap-2">
                  <div
                    className={`inline-flex overflow-hidden relative justify-center items-center w-8 h-8 text-xs bg-slate-600 rounded-full`}
                  >
                    <span className="text-white">
                      {shift.name?.[0]}
                      {shift.name?.[shift.name?.length - 1]}
                    </span>
                  </div>
                  <div>
                    <p className="text-slate-900 font-bold text-xxs">
                      {shift.name}
                    </p>
                    <p className="text-xxs text-slate-900">
                      {shift.hours.toFixed(1)} hrs
                    </p>
                  </div>
                </div>
              </div>
              <ResizableDailyShiftCard
                paidBreakInputsEnabled={props.paidBreakInputsEnabled}
                restBreakRegulation={props.restBreakRegulation}
                openShift
                laborLawViolations={props.laborLawViolations}
                weekly_or_daily="daily"
                shift_info={shift}
                multipleShifts={false}
                locked_mode={
                  Boolean(!edit_mode || props.displayMode || props.lockAllShifts)
                }
                addShift={props.addShift}
                get_t_str={props.get_t_str}
                date_name={date_name}
                role_names={props.role_names}
                role_types={props.role_types}
                saveShiftFinished={props.saveShiftFinished}
                setSaveShiftFinished={props.setSaveShiftFinished}
                d={props.dowSelected}
                setCopiedShift={props.setCopiedShift}
                copiedShift={props.copiedShift}
                businessWeekStartDayIndex={props.businessWeekStartDayIndex}
                start_qhnum={props.start_qhnum}
                schedule_day_end_qhnum={props.schedule_day_end_qhnum}
                defaultBreakLengthHours={props.defaultBreakLengthHours}
                breakRequiredWhenShiftLengthExceeds={
                  props.breakRequiredWhenShiftLengthExceeds
                }
                secondBreakShiftLengthThreshold={
                  props.secondBreakShiftLengthThreshold
                }
                businessDeclineShiftOptionEnabled={
                  props.businessDeclineShiftOptionEnabled
                }
                store_team_member_weekly_info={
                  props.store_team_member_weekly_info
                }
                day_in_past={day_in_past}
                showActualTimes={props.showActualHours}
                actualTimesByPublishedId={props.actualTimesByPublishedId}
                coveredPublishedIds={props.coveredPublishedIds}
                coverageOwners={props.coverageOwners}
                hour_increment={hour_increment}
                previousEndTime={start_h}
                windowWidth={props.windowWidth}
              />
            </div>
          );
        })}
        {props.store_team_member_weekly_info_view?.map((p, i) => {
          // Check if this is a role header
          if (p.isRoleHeader) {
            const info = groupHeaderInfo[p.id];
            const roleColorClass = props.role_names?.find(
              (r) => r.role_name === p.roleName
            )?.color;
            return (
              <div
                key={p.id}
                className="w-full border-t border-slate-200 bg-slate-50 flex items-center gap-2.5 px-4 relative z-10"
                style={{ height: "36px" }}
              >
                {roleColorClass && (
                  <span className={`w-2.5 h-2.5 rounded-[3px] shrink-0 ${roleColorClass}`} />
                )}
                <h3 className="text-xs font-bold text-slate-700 uppercase tracking-wider whitespace-nowrap">
                  {p.roleName}
                </h3>
                {info && (
                  <span className="text-xs text-slate-500 whitespace-nowrap">
                    {info.people} {info.people === 1 ? "person" : "people"} · {info.shifts}{" "}
                    {info.shifts === 1 ? "shift" : "shifts"} ·{" "}
                    {showDayActualHours
                      ? `${info.actualHours.toFixed(2)} / ${info.scheduledHoursForPair.toFixed(2)} h`
                      : `${info.hours.toFixed(2)} h`}
                  </span>
                )}
              </div>
            );
          }

          const [
            locked_person,
            person_day_shift,
            person_day_request_off,
            person_day_availability,
            person_day_time_off_requests,
            person_day_other_store_shift,
            person_day_shift_all,
            person_day_unscheduled_hidden,
          ] = props.get_person_shift_info(
            p,
            date_str,
            date_dow,
            day_shifts,
            day_request_off,
            dow_availability,
            day_time_off_requests,
            day_other_store_shifts
          );
          //shift_info={props.person_day_shift[0]}
          const splitAvailability = person_day_availability?.[0]?.available_to_2
            ? true
            : false;
          // Against the unfiltered list, as the week view does. Comparing with
          // the actual-mode list would report every plan-only shift this mode
          // drops as belonging to a hidden department, with no filter applied.
          // The same rule as the week view: in actual mode a marker stands for
          // work the department filter hid, so it is built from the punches.
          // Walking the draft as well would mark the plan an employee departed
          // from, and retiming cards that already carry their worked times
          // only blanks them, because a punch nobody scheduled has no
          // published shift to look up.
          const personDayOutOfFilterShifts = props.showActualHours
            ? person_day_unscheduled_hidden || []
            : getOutOfFilterShifts(
                p,
                [
                  ...(person_day_shift_all || []),
                  ...(person_day_other_store_shift || []),
                ],
                unfilteredDayShifts
              ).concat(person_day_unscheduled_hidden || []);

          return (
            <div
              key={p.id}
              className="w-full border-t border-gray-200 py-2 flex items-center relative"
            >
              <div className="w-[15%] pl-2 pr-4">
                <PersonCard
                  openDirectMessageWith={props.openDirectMessageWith}
                  currentUserId={props.currentUserId}
                  openEmployeeProfile={props.openEmployeeProfile}
                  key={p.id}
                  p={p}
                  role_names={props.role_names}
                  updatePersonInfo={props.updatePersonInfo}
                  lock_person={props.lock_person}
                  locked_person={locked_person}
                  id={p.id}
                  week_in_past={props.week_in_past}
                  role_types={props.role_types}
                  week_already_started={props.week_already_started}
                  view="daily"
                  highlightedEmployees={props.highlightedEmployees}
                  proficiencyStarsCount={props.proficiencyStarsCount}
                  proficiencyFromLMSEnabled={props.proficiencyFromLMSEnabled}
                  laborLawViolations={props.laborLawViolations}
                  laborLawEnabled={props.laborLawEnabled}
                  actualEmployeeWarnings={props.actualComplianceWarnings?.byEmployee[p.id] || []}
                  showActualHours={props.showActualHours}
                  actualHours={props.actualHoursByMember?.[p.id] || 0}
                  scheduledHoursToDate={
                    props.scheduledHoursToDateByMember?.[p.id] || 0
                  }
                />
              </div>
              {person_day_shift.length > 0 ? (
                <>
                  {person_day_shift.map((shift, index) => {
                    // Computed once per shift. These were being rebuilt up to ten times a
                    // shift inside the render loop, each call allocating a fresh object.
                    const shiftGeometry = actualGeometry(shift, p?.id);
                    const drawnShift = displayShift(shift, p?.id);
                    let previousEndTime =
                      index > 0
                        ? displayEnd(person_day_shift[index - 1], p?.id)
                        : start_h;
                    const multipleShifts = person_day_shift.length > 1;
                    return (
                      <>
                      {!multipleShifts ? (
                        <ResizableDailyShiftCard
                          actualWarningsByEntry={props.actualComplianceWarnings?.byEntry}
                          key={i}
                          weeky_or_daily="daily"
                          shift_info={shift}
                          shifts_info={person_day_shift}
                          multipleShifts={multipleShifts}
                          lockAllShifts={props.lockAllShifts}
                          p={p}
                          locked_mode={
                            !edit_mode | props.displayMode | locked_person ||
                            props.lockAllShifts
                          }
                          addShift={props.addShift}
                          get_t_str={props.get_t_str}
                          date_name={date_name}
                          availability_info={person_day_availability[0]}
                          role_names={props.role_names}
                          saveShiftFinished={props.saveShiftFinished}
                          setSaveShiftFinished={props.setSaveShiftFinished}
                          d={props.dowSelected}
                          setCopiedShift={props.setCopiedShift}
                          copiedShift={props.copiedShift}
                          time_off_conflict={
                            person_day_time_off_requests.length > 0
                          }
                          person_day_time_off_requests={
                            person_day_time_off_requests
                          }
                          role_types={props.role_types}
                          addMultipleShifts={props.addMultipleShifts}
                          businessWeekStartDayIndex={
                            props.businessWeekStartDayIndex
                          }
                          start_qhnum={props.start_qhnum}
                          schedule_day_end_qhnum={props.schedule_day_end_qhnum}
                          storeTimezone={props.storeTimezone}
                          frequentShifts={props.frequentShifts}
                          day_in_past={day_in_past}
                          showActualTimes={props.showActualHours}
                          actualTimesByPublishedId={props.actualTimesByPublishedId}
                          coveredPublishedIds={props.coveredPublishedIds}
                          coverageOwners={props.coverageOwners}
                          post_missed_shift={props.post_missed_shift}
                          showUnpublishedShifts={props.showUnpublishedShifts}
                          defaultBreakLengthHours={
                            props.defaultBreakLengthHours
                          }
                          hour_increment={hour_increment}
                          previousEndTime={previousEndTime}
                          actualGeometry={shiftGeometry}
                          isCopilotOn={props.isCopilotOn}
                          breakRequiredWhenShiftLengthExceeds={
                            props.breakRequiredWhenShiftLengthExceeds
                          }
                          secondBreakShiftLengthThreshold={
                            props.secondBreakShiftLengthThreshold
                          }
                          paidBreakInputsEnabled={
                            props.paidBreakInputsEnabled
                          }
                          businessDeclineShiftOptionEnabled={
                            props.businessDeclineShiftOptionEnabled
                          }
                          restBreakRegulation={
                            props.restBreakRegulation
                          }
                          windowWidth={props.windowWidth}
                          laborLawViolations={props.laborLawViolations}
                        />
                      ) : (
                        <div
                          style={{
                            height: 32,
                            width:
                              (shiftGeometry?.length ??
                                shift?.shift_length) *
                                hour_increment +
                              "%",
                            marginLeft:
                              ((shiftGeometry?.start ??
                                shift?.shift_start) -
                                previousEndTime) *
                                hour_increment +
                              "%",
                            zIndex: 9,
                            position: "relative",
                            cursor: "default",
                          }}
                        >
                          <ShiftCard
                            actualWarningsByEntry={props.actualComplianceWarnings?.byEntry}
                            key={i}
                            weeky_or_daily="daily"
                            shift_info={shift}
                            shifts_info={person_day_shift}
                            multipleShifts={multipleShifts}
                            lockAllShifts={props.lockAllShifts}
                            p={p}
                            locked_mode={
                              !edit_mode | props.displayMode | locked_person ||
                              props.lockAllShifts
                            }
                            addShift={props.addShift}
                            get_t_str={props.get_t_str}
                            date_name={date_name}
                            availability_info={person_day_availability[0]}
                            role_names={props.role_names}
                            saveShiftFinished={props.saveShiftFinished}
                            setSaveShiftFinished={props.setSaveShiftFinished}
                            d={props.dowSelected}
                            setCopiedShift={props.setCopiedShift}
                            copiedShift={props.copiedShift}
                            time_off_conflict={
                              person_day_time_off_requests.length > 0
                            }
                            person_day_time_off_requests={
                              person_day_time_off_requests
                            }
                            role_types={props.role_types}
                            addMultipleShifts={props.addMultipleShifts}
                            businessWeekStartDayIndex={
                              props.businessWeekStartDayIndex
                            }
                            start_qhnum={props.start_qhnum}
                            schedule_day_end_qhnum={props.schedule_day_end_qhnum}
                            storeTimezone={props.storeTimezone}
                            frequentShifts={props.frequentShifts}
                            day_in_past={day_in_past}
                            showActualTimes={props.showActualHours}
                            actualTimesByPublishedId={props.actualTimesByPublishedId}
                            coveredPublishedIds={props.coveredPublishedIds}
                            coverageOwners={props.coverageOwners}
                            post_missed_shift={props.post_missed_shift}
                            showUnpublishedShifts={props.showUnpublishedShifts}
                            defaultBreakLengthHours={
                              props.defaultBreakLengthHours
                            }
                            hour_increment={hour_increment}
                            previousEndTime={previousEndTime}
                          actualGeometry={shiftGeometry}
                            editShiftsInPastEnabled={
                              props.editShiftsInPastEnabled
                            }
                            isCopilotOn={props.isCopilotOn}
                            breakRequiredWhenShiftLengthExceeds={
                              props.breakRequiredWhenShiftLengthExceeds
                            }
                            secondBreakShiftLengthThreshold={
                              props.secondBreakShiftLengthThreshold
                            }
                            paidBreakInputsEnabled={
                              props.paidBreakInputsEnabled
                            }
                            businessDeclineShiftOptionEnabled={
                              props.businessDeclineShiftOptionEnabled
                            }
                            restBreakRegulation={
                              props.restBreakRegulation
                            }
                            windowWidth={props.windowWidth}
                            laborLawViolations={props.laborLawViolations}
                          />
                      </div>
                    )}
                      {multipleShifts &&
                        unpaidBreaksToDraw(drawnShift).map((entry, breakIndex) =>
                          breakFitsShift(
                            drawnShift,
                            entry?.break_start,
                            entry?.break_length
                          ) ? (
                            <div
                              key={`unpaid-${breakIndex}-${entry?.break_start}`}
                              style={{
                                height: 32,
                                width:
                                  entry.break_length * hour_increment + "%",
                                marginLeft:
                                  (entry.break_start - start_h) *
                                    hour_increment +
                                  15 +
                                  "%",
                                position: "absolute",
                                cursor: "default",
                                zIndex: 10,
                              }}
                            >
                              <DailyBreakCard draggable={showPlanCells} />
                            </div>
                          ) : null
                        )}
                      {multipleShifts &&
                        drawnShift?.paid_breaks?.map((paidBreak, paidBreakIndex) => {
                          const paidBreakDuration =
                            paidBreak?.break_duration ||
                            paidBreak?.break_length ||
                            0;

                          if (
                            paidBreak?.break_start === undefined ||
                            paidBreakDuration <= 0
                          ) {
                            return null;
                          }

                          return (
                            <div
                              key={`paid-break-${paidBreakIndex}-${paidBreak.break_start}`}
                              className="absolute bg-emerald-200 border border-emerald-700 h-3 rounded-sm pointer-events-none"
                              style={{
                                width: paidBreakDuration * hour_increment + "%",
                                marginLeft:
                                  (paidBreak.break_start - start_h) * hour_increment +
                                  15 +
                                  "%",
                                top: "calc(50% - 16px)",
                                borderTop: "none",
                                borderTopLeftRadius: 0,
                                borderTopRightRadius: 0,
                                zIndex: 11,
                              }}
                            ></div>
                          );
                        })}
                      </>
                    );
                  })}
                  {personDayOutOfFilterShifts.length > 0 && (
                    <FilteredDepartmentShiftCard
                      shifts={personDayOutOfFilterShifts}
                      roleNames={props.role_names}
                      getTime={props.get_t_str}
                      daily
                      compact
                      onLightCard
                    />
                  )}
                </>
              ) : personDayOutOfFilterShifts.length > 0 &&
                person_day_other_store_shift.length === 0 ? (
                <FilteredDepartmentShiftCard
                  shifts={personDayOutOfFilterShifts}
                  roleNames={props.role_names}
                  getTime={props.get_t_str}
                  daily
                />
              ) : !edit_mode | props.displayMode | locked_person ? (
                <div></div>
              ) : props.showActualHours ? null : (
                <div
                  style={{
                    width: "85%",
                    marginLeft: "0%",
                    zIndex: 9,
                    height: 32,
                  }}
                >
                  <NewShiftCard
                    weekly_or_daily="daily"
                    p={p}
                    date_str={date_str}
                    addShift={props.addShift}
                    store_id={props.store_id}
                    get_t_str={props.get_t_str}
                    date_name={date_name}
                    availability_info={person_day_availability[0]}
                    role_names={props.role_names}
                    saveShiftFinished={props.saveShiftFinished}
                    setSaveShiftFinished={props.setSaveShiftFinished}
                    d={props.dowSelected}
                    copiedShift={props.copiedShift}
                    setCopiedShift={props.setCopiedShift}
                    addMultipleShifts={props.addMultipleShifts}
                    role_types={props.role_types}
                    businessWeekStartDayIndex={props.businessWeekStartDayIndex}
                    start_qhnum={props.start_qhnum}
                    schedule_day_end_qhnum={props.schedule_day_end_qhnum}
                    frequentShifts={props.frequentShifts}
                    person_day_time_off_requests={person_day_time_off_requests}
                    defaultBreakLengthHours={props.defaultBreakLengthHours}
                    breakRequiredWhenShiftLengthExceeds={
                      props.breakRequiredWhenShiftLengthExceeds
                    }
                    secondBreakShiftLengthThreshold={
                      props.secondBreakShiftLengthThreshold
                    }
                    hasNoCapableRoles={p?.available_role_info?.length === 0}
                    updatePersonInfo={props.updatePersonInfo}
                    paidBreakInputsEnabled={props.paidBreakInputsEnabled}
                    businessDeclineShiftOptionEnabled={
                      props.businessDeclineShiftOptionEnabled
                    }
                    restBreakRegulation={props.restBreakRegulation}
                  />
                </div>
              )}

              {/* Time off records the day rather than planning it, so it
                  stays in actual mode to explain the empty row. */}
              {person_day_time_off_requests &&
                person_day_time_off_requests[0] && (
                  <div
                    className={`bg-red-200 absolute h-10 rounded-lg flex items-center`}
                    style={{
                      // Check if start_qhnum and end_qhnum are present for specific time range
                      ...(person_day_time_off_requests[0].start_qhnum &&
                          person_day_time_off_requests[0].end_qhnum
                        ? {
                            // Calculate width and position like preferences
                            width: (person_day_time_off_requests[0].end_qhnum -
                                  Math.max(person_day_time_off_requests[0].start_qhnum, start_h)) *
                                  hour_increment + "%",
                            marginLeft: Math.max(
                              (person_day_time_off_requests[0].start_qhnum - start_h) * hour_increment + 15,
                              15
                            ) + "%",
                          }
                        : {
                            // Fall back to full width when specific times aren't available
                            width: "85%",
                            marginLeft: "15%",
                          }
                      ),
                      zIndex: 5,
                    }}
                  >
                    <div className={`px-6 text-red-600 font-bold`}>
                      Time Off
                      {/* Optionally show the time range if available */}
                      {/* {person_day_time_off_requests[0].start_qhnum &&
                      person_day_time_off_requests[0].end_qhnum && (
                        <span className="text-xs ml-2">
                          ({get_t_str_shortened(person_day_time_off_requests[0].start_qhnum)} -
                          {get_t_str_shortened(person_day_time_off_requests[0].end_qhnum)})
                        </span>
                      )} */}
                    </div>
                  </div>
                )}

              {preferenceChecked &&
                person_day_availability[0] &&
                person_day_availability[0].preferred_to > 0 && (
                  <div
                    className={`border-2 border-green-300 absolute h-10 rounded-lg`}
                    style={{
                      width:
                        (person_day_availability[0].preferred_to -
                          Math.max(
                            person_day_availability[0].preferred_from,
                            start_h
                          )) *
                          hour_increment +
                        "%",
                      marginLeft:
                        Math.max(
                          person_day_availability[0].preferred_from - start_h,
                          0
                        ) *
                          hour_increment +
                        15 +
                        "%",
                    }}
                  ></div>
                )}
              {availabilityChecked &&
                person_day_availability &&
                person_day_availability[0] && (
                  <div
                    className={`bg-slate-300  absolute h-10 rounded-lg`}
                    style={{
                      width:
                        Math.min(
                          (person_day_availability[0].available_from === 0 &&
                            person_day_availability[0].available_to === 24) ||
                            person_day_availability[0].available_from <= start_h
                            ? 0
                            : (person_day_availability[0].available_from -
                                start_h) *
                                hour_increment,
                          85
                        ) + "%",
                      marginLeft: 15 + "%",
                    }}
                  ></div>
                )}
              {availabilityChecked &&
                person_day_availability &&
                person_day_availability[0] && (
                  <div
                    className={`bg-slate-300 absolute h-10 rounded-lg`}
                    style={{
                      width: person_day_availability[0].available_from_2
                        ? Math.min(
                            (person_day_availability[0].available_from === 0 &&
                              person_day_availability[0].available_to === 24) ||
                              person_day_availability[0].available_to >= end_h
                              ? 0
                              : (person_day_availability[0].available_from_2 -
                                  person_day_availability[0].available_to) *
                                  hour_increment,
                            85
                          ) + "%"
                        : Math.min(
                            (person_day_availability[0].available_from === 0 &&
                              person_day_availability[0].available_to === 24) ||
                              person_day_availability[0].available_to >= end_h
                              ? 0
                              : (end_h -
                                  person_day_availability[0].available_to) *
                                  hour_increment,
                            85
                          ) + "%",
                      marginLeft:
                        Math.max(
                          (person_day_availability[0].available_to - start_h) *
                            hour_increment +
                            15,
                          15
                        ) + "%",
                    }}
                  ></div>
                )}
              {availabilityChecked &&
                person_day_availability &&
                person_day_availability[0] &&
                person_day_availability[0].available_to_2 && (
                  <div
                    className={`bg-slate-300 absolute h-10 rounded-lg`}
                    style={{
                      width:
                        Math.min(
                          (person_day_availability[0].available_from === 0 &&
                            person_day_availability[0].available_to === 24) ||
                            person_day_availability[0].available_to_2 >= end_h
                            ? 0
                            : (end_h -
                                person_day_availability[0].available_to_2) *
                                hour_increment,
                          85
                        ) + "%",
                      marginLeft:
                        Math.max(
                          (person_day_availability[0].available_to_2 -
                            start_h) *
                            hour_increment +
                            15,
                          15
                        ) + "%",
                    }}
                  ></div>
                )}
              {availabilityChecked && showPlanCells &&
                person_day_other_store_shift?.length > 0 &&
                person_day_other_store_shift?.map((shift, index) => (
                  <div
                    key={index}
                    className={`bg-slate-200 text-slate-400 text-sm absolute h-10 rounded-lg flex items-center px-4 overflow-hidden whitespace-nowrap`}
                    title={otherStoreShiftLabel(shift, get_t_str_shortened)}
                    style={{
                      width:
                        (shift?.shift_end -
                          Math.max(shift?.shift_start, start_h)) *
                          hour_increment +
                        "%",
                      marginLeft:
                        Math.max(shift?.shift_start - start_h, 0) *
                          hour_increment +
                        15 +
                        "%",
                    }}
                  >
                    {otherStoreShiftLabel(shift, get_t_str_shortened)}
                  </div>
                ))}
              {showPlanCells &&
                person_day_other_store_shift?.length > 0 &&
                personDayOutOfFilterShifts.length > 0 && (
                  <FilteredDepartmentShiftCard
                    shifts={personDayOutOfFilterShifts}
                    roleNames={props.role_names}
                    getTime={props.get_t_str}
                    daily
                    compact
                    onLightCard
                  />
                )}
            </div>
          );
        })}
      </div>

      <div
        style={{ boxShadow: "0 -4px 12px rgba(15, 23, 42, 0.06)" }}
        className={`w-full bg-white border-t border-gray-200 bottom-0 left-0 sticky z-20 ${
          showIntraday ? "pb-3" : ""
        }`}
      >
        {/* Same control as the week view's, so the mode can be changed from
            whichever view you happen to be in rather than only from the other
            one. Both write the flag HomeDisplay2 owns. */}
        {/* Centered against the hour axis row, which is a fixed h-8 band, so
            the toggle sits on the same line as the hour labels rather than
            riding the top edge of the footer. */}
        <div className="absolute left-10 top-0 h-8 flex items-center z-10">
          <div
            className="flex gap-0.5 rounded-lg bg-slate-100 p-[2px]"
            role="tablist"
            aria-label="Planned or actual"
          >
            {[
              { label: "Planned", checked: false },
              { label: "Actual", checked: true },
            ].filter(({ checked }) => !checked || props.actualHoursAvailable !== false).map(({ label, checked }) => {
              const active = !!props.checkedMetricsToggle === checked;
              const unavailable =
                checked && props.weekHasStartedForActuals === false;
              return (
                <Tooltip
                  key={label}
                  title={unavailable ? "This week has not started yet" : ""}
                >
                  <span className="inline-flex">
                    <button
                      type="button"
                      role="tab"
                      aria-selected={active}
                      disabled={unavailable}
                      onClick={() => {
                        if (!active && !unavailable) {
                          props.handleChangeMetricsToggle?.({
                            target: { checked },
                          });
                        }
                      }}
                      className={`px-2.5 py-0.5 rounded-md text-xxs font-semibold transition-colors duration-150 ${
                        unavailable
                          ? "text-slate-300 cursor-not-allowed"
                          : active
                          ? "bg-white text-violet-700 shadow-sm"
                          : "text-slate-500 hover:text-slate-700"
                      }`}
                    >
                      {label}
                    </button>
                  </span>
                </Tooltip>
              );
            })}
          </div>
        </div>
        {hasIntradayModel && (
          <button
            type="button"
            className="absolute left-1 top-0.5 w-7 h-7 rounded-md flex items-center justify-center text-slate-500 hover:bg-slate-100"
            onClick={handleExpandClick}
            aria-expanded={isExpanded}
            aria-label={
              isExpanded
                ? "Collapse intraday staffing levels"
                : "Expand intraday staffing levels"
            }
          >
            {isExpanded ? (
              <ExpandMoreIcon sx={{ fontSize: "20px" }} />
            ) : (
              <ExpandLessIcon sx={{ fontSize: "20px" }} />
            )}
          </button>
        )}

        <div
          className={`w-full flex text-xs text-slate-500 h-8 items-center ${
            hasIntradayModel && !isExpanded ? "cursor-pointer" : ""
          }`}
          onClick={handleExpandAxisClick}
          onKeyDown={handleExpandAxisKeyDown}
          role={hasIntradayModel && !isExpanded ? "button" : undefined}
          tabIndex={hasIntradayModel && !isExpanded ? 0 : undefined}
          aria-expanded={hasIntradayModel ? isExpanded : undefined}
          aria-label={
            hasIntradayModel && !isExpanded
              ? "Expand intraday staffing levels"
              : undefined
          }
        >
          <h5 className="w-[15%] text-right">
            {end_h !== undefined &&
            start_h !== undefined &&
            !(end_h === 0 && start_h === 0)
              ? `${start_h}A`
              : ""}
          </h5>
          {end_h !== undefined &&
            start_h !== undefined &&
            !(end_h === 0 && start_h === 0) &&
            [...Array(end_h - start_h).keys()].map((v, i) => {
              return (
                <h5
                  key={i}
                  className="text-right"
                  style={{ width: hour_increment + "%" }}
                >
                  {format_hour(i + 1 + start_h)}
                </h5>
              );
            })}
        </div>
        {!hasIntradayModel && (
          <div className="flex items-center gap-4 px-6 py-1.5">
            <div className="w-36 shrink-0">
            <DailyNoLaborModelMetricsCard
              actualHoursAvailable={props.actualHoursAvailable}
              actual_schedule={day_shifts}
              roleTypes={props.summaryRoleTypes}
              publishedScheduledHours={Object.values(props.scheduledHoursByMemberDate || {}).reduce((sum, days) => sum + (days[date_str] || 0), 0)}
              actualCards={(props.actualCards || []).filter((card) => card.date === date_str)}
              checkedMetricsToggle={props.checkedMetricsToggle}
              day_of_week_str={date.toLocaleDateString("en-us", { weekday: "short" })}
            />
            </div>
            <ScheduledCoverageChart
              height={68}
              shifts={props.checkedMetricsToggle && props.actualHoursAvailable !== false ? (props.publishedCoverageShifts || []).filter(shift => shift.date === date_str) : day_shifts}
              roleTypes={props.summaryRoleTypes}
              defaultHours={dow_default_operating_hours}
              dailyHours={day_operating_hours}
            />
          </div>
        )}
        {showIntraday && (
          <div className="flex border-t border-gray-100 pt-1.5">
            <div className="w-[15%] flex flex-col items-center">
              <div className="w-28 flex flex-col justify-center items-center">
                <div
                  className="w-24 h-12 mt-0.5 flex flex-col justify-center items-center rounded-lg"
                  style={{
                    backgroundColor: props.calculate_color(
                      gradeActualSeries,
                      gradeNeededSeries
                    ),
                  }}
                >
                  <h3 className="text-2xl font-bold text-white">
                    {props.calculate_letter(
                      gradeActualSeries,
                      gradeNeededSeries
                    )}
                  </h3>
                </div>
              </div>
              <div className="mt-2">
                <div className="bg-white w-24 h-24 flex flex-col justify-center items-center rounded-lg border border-slate-200">
                  <h5 className="text-xxs text-slate-500">{label1}</h5>
                  <h5 className="text-xxs text-slate-500">hours</h5>
                  <div className="text-xl font-bold text-slate-900 tabular-nums mt-1">
                    {tileHours(gradeNeededSeries)}
                  </div>
                </div>
                <div className="bg-white w-24 h-24 mt-2 flex flex-col justify-center items-center rounded-lg border border-slate-200">
                  <h5 className="text-xxs text-slate-500">{label2}</h5>
                  <h5 className="text-xxs text-slate-500">hours</h5>
                  <div className="text-xl font-bold text-slate-900 tabular-nums mt-1">
                    {tileHours(gradeActualSeries)}
                  </div>
                </div>
              </div>
            </div>
            {employmentGuide ? (
              <div className="w-[85%] h-64 relative">
                <div>
                  <VisualCustomLineChart
                    type="daily"
                    data={data.summary}
                    roleTypes={data.roleTypes}
                    date_name={props.date_name}
                    height={264}
                    isSmall={true}
                    label1={label1}
                    label2={label2}
                    start_h={start_h}
                    end_h={end_h}
                    hour_increment={hour_increment}
                  />
                </div>
              </div>
            ) : coverageGraph ? (
              <div className="w-[85%] h-64 relative px-4 py-2">
                <div className="absolute top-1 right-1 flex items-center">
                  <Tooltip title="Employment Guide">
                    <IconButton onClick={handleEmploymentGuideClick}>
                      <StackedBarChartIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
            ) : (
              <div>Charts not rendering</div>
            )}
          </div>
        )}
      </div>
      <VisualChartModal
        open={hasIntradayModel && openChart}
        handleClose={handleCloseChart}
        forecasted_labor_day={forecasted_labor_day}
        actual_schedule_labor_day={actual_schedule_labor_day}
        calculated_earned_labor_day={calculated_earned_labor_day}
        actual_used_labor_vs_earned_day={actual_used_labor_vs_earned_day}
        actual_schedule={day_shifts}
        agg_column={props.agg_column}
        get_t_str={get_t_str}
        combine_data={props.combine_data}
        dow_default_operating_hours={dow_default_operating_hours}
        day_operating_hours={day_operating_hours}
        date_name={date_name}
        earned_toggle={dailyChartEarnedToggle}
      />
      <VisualDailyReportModal2
        laborLawEnabled={props.laborLawEnabled}
        printHoursShownEnabled={props.printHoursShownEnabled}
        // Same value the button's label reads, so the report cannot open
        // titled Planned under a button that said After Action. This is the
        // mode itself rather than the chart's earned toggle, which also
        // requires the day to have labor data.
        earned_toggle={!!props.checkedMetricsToggle}
        open={openDailyReport2}
        handleClose={handleCloseDailyReport2}
        forecasted_labor_day={forecasted_labor_day}
        actual_schedule_labor_day={actual_schedule_labor_day}
        calculated_earned_labor_day={calculated_earned_labor_day}
        actual_used_labor_vs_earned_day={actual_used_labor_vs_earned_day}
        actual_schedule={day_shifts}
        agg_column={props.agg_column}
        get_t_str={get_t_str}
        combine_data={props.combine_data}
        dow_default_operating_hours={dow_default_operating_hours}
        day_operating_hours={day_operating_hours}
        date_name={date_name}
        date_str={date_str}
        store_team_member_weekly_info={props.store_team_member_weekly_info}
        daily_batch_guidance={daily_batch_guidance}
        daily_intraday_metrics={daily_intraday_metrics}
        forecast_sales={forecast_sales}
        calculate_daily_budget_score={props.calculate_daily_budget_score}
        calculate_intraday_coverage_score={
          props.calculate_intraday_coverage_score
        }
        calculate_letter={props.calculate_letter}
        calculate_color={props.calculate_color}
        daily_weather={daily_weather}
        role_types={props.role_types}
        role_names={props.role_names}
        start_qhnum={props.start_qhnum}
        schedule_day_end_qhnum={props.schedule_day_end_qhnum}
        actual_used_schedule={used_day_shifts}
        store_id={props.store_id}
        refreshActualsForDate={props.refreshActualsForDate}
        pos_provider={props.pos_provider}
      />
    </div>
  );
}
